import Cookies from 'js-cookie';

const CookieStorageBuilder = (cookies: Cookies.CookiesStatic) => ({
  setCookie: (key: string, value: string, options?: Cookies.CookieAttributes) =>
    cookies.set(key, value, {
      path: '/',
      domain: '',
      secure: process.env.NODE_ENV === 'production' ? true : false,
      httpOnly: false,
      sameSite: 'Lax',
      ...options
    }),
  getCookie: (key: string) => cookies.get(key),
  removeCookie: (key: string) => cookies.remove(key),
  clearAllCookies: () => {
    const allCookies = cookies.get();

    Object.keys(allCookies).forEach((cookieName) => {
      cookies.remove(cookieName);
    });
  },
  dotremoveCookie: (key: string, domain?: string) => cookies.remove(key, { domain: domain ?? '' })
});

export const cookieStorage = CookieStorageBuilder(Cookies);

const COOKIE_BASE_NAME = 'fadhili_master';

export const COOKIE_ACCESS_TOKEN = `${COOKIE_BASE_NAME}_acst` as const;
export const COOKIE_REFRESH_TOKEN = `${COOKIE_BASE_NAME}_rfst` as const;
export const COOKIE_SAVE_USER_ID = `${COOKIE_BASE_NAME}_suid` as const;
export const COOKIE_MOBILE = `${COOKIE_BASE_NAME}_mobile` as const;
export const COOKIE_USER_FILE_ID = `${COOKIE_BASE_NAME}_userFileId` as const;
export const STORAGE_LOCAL_COLLAPSED = `${COOKIE_BASE_NAME}_collapsed` as const;
export const STORAGE_LOCAL_MENU_COLLAPSED = `${COOKIE_BASE_NAME}_menu_collapsed` as const;
export const STORAGE_LOCAL_USER_ID = `${COOKIE_BASE_NAME}_userId` as const;
export const STORAGE_LOCAL_LOGIN_MOBILE_ID = `${COOKIE_BASE_NAME}_login_mobile_id` as const;
export const STORAGE_LOCAL_LOGIN_ID = `${COOKIE_BASE_NAME}_login_id` as const;
export const STORAGE_LOCAL_LOGIN_ID_SAVE = `${COOKIE_BASE_NAME}_login_save` as const;

export const COOKIE_PKG = `${COOKIE_BASE_NAME}_pkg` as const;
export const COOKIE_PKG_ID = `${COOKIE_BASE_NAME}_pkg_id` as const;
